KMVP.donutChart = {

    updateCharts: function() {
        $('.donut-chart').each(function () {
            var percentage = $(this).find(".chart-label").attr("data-percentage");
            updateDonutChart("#" + this.id, percentage, true, 1.2);
            updateDonutChart("#" + this.id + "-inner", percentage, true, 4.2);
        });


    }

};

$(document).ready(function () {
    with (KMVP.donutChart) {
        updateCharts();
    }
});

